import { Injectable } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { CustomValidator } from 'src/app/shared/directives/custom.validator';

@Injectable({
  providedIn: 'root'
})
export class RequestValidationsService {

  constructor() { }
  public myreg =
    /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+$/;

  RequestMainInfoValidation(defualtValue?: any): object {
    const validation: object = {
      name_ar: new FormControl(defualtValue?.name_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(100)]),
      name_en: new FormControl(defualtValue?.name_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(100), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
      description_ar: new FormControl(defualtValue?.description_ar || '', [Validators.maxLength(255)]),
      description_en: new FormControl(defualtValue?.description_en || '', [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
      category_id: new FormControl(defualtValue?.category.id || null, [Validators.required])
    }
    return validation;
  }

  RequestDetails(defualtValue?: any): object {
    const validation: object = {
      details: new FormArray(
        defualtValue?.details.length ?
          [...defualtValue?.details.map((item: { key_en: string, value_en: string, key_ar: string, value_ar: string, order: string, id_en: string, id_ar: string }) =>
            new FormGroup({
              key_en: new FormControl(item.key_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
              value_en: new FormControl(item.value_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
              key_ar: new FormControl(item.key_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
              value_ar: new FormControl(item.value_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
              order: new FormControl(item?.order, [Validators.required]),
              id_en: new FormControl(item?.id_en, [Validators.required]),
              id_ar: new FormControl(item?.id_ar, [Validators.required])
            }))]
          : [])
    }

    return validation
  }

  RequestConfigrations(defualtValue?: any): object {
    const validation: object = {
      minimum_price: new FormControl(defualtValue?.minimum_price || '', [Validators.required, Validators.maxLength(20)]),
      reserve_price: new FormControl(defualtValue?.reserve_price || null),
      is_reserve: new FormControl(defualtValue?.is_reserve || false)
    }

    return validation
  }

}
